import React, { useEffect, useState } from 'react'
import DriverInformationView from './components/DriverInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const DriverInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('driver-info', 'Pay for a Road Test', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <DriverInformationView setIsError={setIsError} />
}

export default withTranslation('common')(DriverInformation)
